import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "../../common/api/apiShared";
import { Result } from "../../common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { IProcessingActivityDeleteDialog } from "./ProcessingActivityDeleteDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useProcessingActivityDeleteDialogHooks(props: IProcessingActivityDeleteDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeSystemClick = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<string>) => {
                props.onCloseDialog();
                if (response.success()) {
                    props.onSuccessDelete();
                    snackbar.show(createElement(Trans, { i18nKey: "processingActivityDeleted", values: { name: props.name } }));
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "processingActivityNotDeleted", values: { name: props.name } }), "warning");
                }
            },
        });
    };

    return {
        removeSystemClick,
        inProgress: removeMutation.isLoading,
    };

    async function remove() {
        return await deleteHttp<string>(`/processingActivity/${props.id}`);
    }
}
